module.exports = __webpack_public_path__ + "img/comment.adbd6b61.svg";